export default "__VITE_ASSET__BbtXPHWK__"